"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SapphireMapperLinearFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SapphireMapperLinearFactory = /** @class */ (function (_super) {
    __extends(SapphireMapperLinearFactory, _super);
    function SapphireMapperLinearFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SapphireMapperLinearFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SapphireMapperLinearFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SapphireMapperLinearFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SapphireMapperLinearFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SapphireMapperLinearFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SapphireMapperLinearFactory;
}(contracts_1.ContractFactory));
exports.SapphireMapperLinearFactory = SapphireMapperLinearFactory;
var _abi = [
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "_score",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_scoreMax",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_lowerBound",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_upperBound",
                type: "uint256",
            },
        ],
        name: "map",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b506103bf806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c80638a60d2e114610030575b600080fd5b61005f6004803603608081101561004657600080fd5b5080359060208101359060408101359060600135610071565b60408051918252519081900360200190f35b60008084116100b15760405162461bcd60e51b81526004018080602001828103825260338152602001806103116033913960400191505060405180910390fd5b8183106100ef5760405162461bcd60e51b81526004018080602001828103825260478152602001806102a96047913960600191505060405180910390fd5b8385111561012e5760405162461bcd60e51b81526004018080602001828103825260478152602001806103446047913960600191505060405180910390fd5b6000610140838563ffffffff61017c16565b905061017261016586610159898563ffffffff6101de16565b9063ffffffff61023e16565b849063ffffffff61017c16565b9695505050505050565b6000828211156101d3576040805162461bcd60e51b815260206004820152601e60248201527f536166654d6174683a207375627472616374696f6e206f766572666c6f770000604482015290519081900360640190fd5b508082035b92915050565b6000826101ed575060006101d8565b828202828482816101fa57fe5b04146102375760405162461bcd60e51b81526004018080602001828103825260218152602001806102f06021913960400191505060405180910390fd5b9392505050565b6000808211610294576040805162461bcd60e51b815260206004820152601a60248201527f536166654d6174683a206469766973696f6e206279207a65726f000000000000604482015290519081900360640190fd5b600082848161029f57fe5b0494935050505056fe53617070686972654d61707065724c696e6561723a20746865206c6f77657220626f756e64206d757374206265206c657373207468616e2074686520757070657220626f756e64536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f7753617070686972654d61707065724c696e6561723a20746865206d6178696d756d2073636f72652063616e6e6f74206265203053617070686972654d61707065724c696e6561723a207468652073636f72652063616e6e6f74206265206c6172676572207468616e20746865206d6178696d756d2073636f7265a265627a7a72315820f5246b26fa9b268a3495501151dc9620953702e554c4cff13e910946d83c5cde64736f6c63430005100032";
//# sourceMappingURL=SapphireMapperLinearFactory.js.map